import axios from "axios";
import store from "./store/store";

const url = new URL(process.env.VUE_APP_API_URL);

export const HTTP = axios.create({
  baseURL: `${url.origin}/api`,
  timeout: 10000,
  withCredentials: true
});

HTTP.interceptors.request.use(function(config) {
  if (!store.state.session) return config;
  config.headers["Authorization"] = `Bearer ${store.state.session.token}`;
  return config;
});
